'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            angular.element(document).ready(function() {
                var len = jQuery('.footer-slot').length - 1;
                var x = Math.round(Math.random() * len);

                // FIXME: why is this slot being hidden
                // then immediately shown?
                jQuery('.footer-slot').css('display', 'none');
                jQuery('.footer-slot')
                    .eq(x)
                    .css('display', 'block');
            });
        }
    };
};
